import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

import Button from 'react-bootstrap/Button'

export default function PreviousButton(props) {
  if (props.previous) {
    return (
      <Link to={props.previous}>
        <Button variant="outline-secondary" size="sm">
          <i className="fas fa-caret-left" />&nbsp;Previous
        </Button>
      </Link>
    )
  } else {
    return <React.Fragment />
  }
}

PreviousButton.propTypes = {
  previous: PropTypes.string
}
